<mat-form-field [color]="color" [appearance]="appearance" [floatLabel]="floatLabel">
  @if (label) {
    <mat-label>{{label}}</mat-label>
  }
  <mat-select
    [multiple]="true"
    [formControl]="control"
    [compareWith]="compareById"
    [placeholder]="placeholder"
    [matTooltip]="(control.value?.length || 0) > 1 ? getTooltipString() : ''"
    [matTooltipClass]="'field-tooltip'"
    [matTooltipPosition]="toolTipPosition"
    [required]="required"
    (closed)="onSelectionChange()">
    <mat-select-trigger>
      @if ((control.value?.length || 0) === 1) {
        <span>{{control.value?.[0].description || ''}}</span>
      }
      @if ((control.value?.length || 0) > 1 && (control.value?.length - 1) === exportTypes.length) {
        <span>All</span>
      }
      @if ((control.value?.length || 0) > 1 && (control.value?.length - 1) < exportTypes.length) {
        <span>Multiple</span>
      }
      @if ((control.value?.length || 0) > 1) {
        <span>
          ({{getSelectCount()}})
        </span>
      }
      @if ((control.value?.length || 0) === 0) {
        <span>{{placeholder}}</span>
      }
    </mat-select-trigger>

    @if (selectAllEnabled) {
      <mat-option #allItem [value]="allOption" (click)="onToggleItem(allItem)">All</mat-option>
    }

    @for (option of exportTypes; track option.id) {
      <mat-option #item [value]="option" (click)="onToggleItem(item)">
        {{option.description}}
      </mat-option>
    }
  </mat-select>

  @if (control.hasError('required')) {
    <mat-error>Selection is <strong>required</strong></mat-error>
  }
</mat-form-field>
